module.exports = __webpack_public_path__ + "img/12.983a268a.jpg";